import TablaPicksGrupoSurvivor from './TablaPicksGrupoSurvivor';

export  default TablaPicksGrupoSurvivor;